import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './ProgressBar.st.css.js';
import Heading from '../../Heading';
const ProgressBar = ({ dataHook, progress }) => {
    return (React.createElement("div", { "data-hook": dataHook, className: classes.root },
        React.createElement(Heading, { size: "extraTiny" }, `${progress}%`),
        React.createElement("span", { className: classes.bar },
            React.createElement("span", { className: classes.value, style: { width: progress + '%' } }),
            React.createElement("span", { className: classes.leftover, style: { width: 100 - progress + '%' } }))));
};
ProgressBar.propTypes = {
    dataHook: PropTypes.string,
    progress: PropTypes.number.isRequired,
};
export default ProgressBar;
//# sourceMappingURL=ProgressBar.js.map